import { ErrorMessage } from "formik";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";

const CustomTagsInput = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  placeholder,
  required,
  onChange,
  noMarginBottom,
  ...props
}) => {
  return (
    <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
      {label && (
        <label className="mb-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <TagsInput
        {...field}
        {...props}
        placeholder={placeholder}
        autoComplete={"off"}
        //className="form-control"
        onChange={(event) => {
          if (onChange) {
            onChange(event);
          } else {
            setFieldValue(field.name, event ?? []);
          }
        }}
      />

      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomTagsInput;
